import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIModule } from './ui/ui.module';

import { WidgetModule } from './widget/widget.module';
import { RouterModule } from '@angular/router';
import { ViewFileComponent } from './components/view-file/view-file.component';
import {IconsModule} from "../pages/icons/icons.module";
import {EmployeesRequestsRoutingModule} from "../view/employees-requests/employees-requests-routing.module";
import {UiSwitchModule} from "ngx-ui-switch";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule, TranslatePipe} from "@ngx-translate/core";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import {
  NgbActiveModal,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbPaginationModule,
  NgbTooltipModule
} from "@ng-bootstrap/ng-bootstrap";
import {NgSelectModule} from "@ng-select/ng-select";
import {LightboxModule} from "ngx-lightbox";
import { SharedService } from './services/shared.service';
import { CheckfilePipe } from './pipes/checkfile.pipe';
import { CheckPermissionsDirective } from 'app/core/directives/check-permissions.directive';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { PdfInvoiceComponent } from './components/pdf/pdf-invoice/pdf-invoice.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';

import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'; // a plugin
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from '@fullcalendar/list';
import { AccordionComponent } from './components/accordion/accordion.component';
import { ControlItemsComponent } from './components/accordion/control-items/control-items.component';
import { AddSiteComponent } from './components/add-site/add-site.component';
import { ClientFormSharedComponent } from './components/client-form-shared/client-form-shared.component';
import { NumericValidationDirective } from './directives/numeric-validation.directive';
import { LoadingComponent } from './components/loading/loading.component';
import { NewCardViewComponent } from './components/new-card-view/new-card-view.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { IconEye, IconTrash } from 'angular-tabler-icons/icons';
import { SharedAccordionComponent } from './components/shared-accordion/shared-accordion.component';
import { NewLoaderComponent } from './components/new-loader/new-loader.component';
import { RecursiveListComponent } from './components/recursive-list/recursive-list.component';
import { ErrorViewComponent } from './components/error-view/error-view.component';
import { GetDayArPipe } from 'app/view/modules/pipes/get-day-ar.pipe';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { SelectCompanyComponent } from './components/select-company/select-company.component';
import { ItemStatusPipe } from 'app/view/New-Finances/modules/pipes/item-status.pipe';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CheckboxColorChangeDirective } from './directives/checkbox-color-change.directive';

FullCalendarModule.registerPlugins([
  listPlugin, // register FullCalendar plugins
  dayGridPlugin,
  timeGridPlugin,
  interactionPlugin,
  bootstrapPlugin
]);
@NgModule({
  declarations: [
    ViewFileComponent,
    CheckfilePipe,
    CheckPermissionsDirective,
    SafeHtmlPipe,
    PdfInvoiceComponent,
    CalendarComponent,
    AccordionComponent,
    ControlItemsComponent,
    AddSiteComponent,
    ClientFormSharedComponent,
    NumericValidationDirective,
    LoadingComponent,
    NewCardViewComponent,
    SharedAccordionComponent,
    NewLoaderComponent,
    RecursiveListComponent,
    ErrorViewComponent,
    GetDayArPipe,
    StatisticsComponent,
    SelectCompanyComponent,
    ItemStatusPipe,
    CheckboxColorChangeDirective
  ],
  imports: [
    CommonModule,
    UIModule,
    RouterModule,
    WidgetModule,
    IconsModule,
         UiSwitchModule.forRoot({
      size: 'small',
      color: '#393939',
      switchColor: '#FDB600',
      defaultBgColor: '#ccc',
      defaultBoColor : '#ccc',
      switchOffColor:'#111'
    }),
    FullCalendarModule,
    CarouselModule,
    ReactiveFormsModule,
    FormsModule,
    UIModule,
    TranslateModule,
    NgxIntlTelInputModule,
    NgbPaginationModule,
    NgSelectModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbNavModule,
    NgbPaginationModule,
    NgSelectModule,
    LightboxModule,
    NgbTooltipModule,
    NgbModalModule,
    TablerIconsModule.pick({IconEye,IconTrash}),

  ],
  exports: [
    CommonModule,
    UIModule,
    WidgetModule,
    CommonModule,
    IconsModule,
    // UiSwitchModule.forRoot({
    //   size: 'small',
    //   color: '#393939',
    //   switchColor: '#FDB600',
    //   defaultBgColor: '#ccc',
    //   defaultBoColor : '#ccc',
    //   switchOffColor:'#111'
    // }),
    ReactiveFormsModule,
    FormsModule,
    UIModule,
    TranslateModule,
    NgxIntlTelInputModule,
    NgbPaginationModule,
    NgSelectModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbNavModule,
    NgbPaginationModule,
    NgSelectModule,
    LightboxModule,
    NgbTooltipModule,
    CheckfilePipe,
    SafeHtmlPipe,
    CheckPermissionsDirective,
    ViewFileComponent,
    PdfInvoiceComponent,
    CalendarComponent,
    AccordionComponent,
    TranslateModule,
    TranslatePipe,
    NumericValidationDirective,
    LoadingComponent,
    NewCardViewComponent,
    SharedAccordionComponent,
    NewLoaderComponent,
    RecursiveListComponent,
    ErrorViewComponent,
    GetDayArPipe,
    StatisticsComponent,
    SelectCompanyComponent,
    ItemStatusPipe,
    CheckboxColorChangeDirective
  ],
  providers:[
    SharedService,
    NgbActiveModal,
  ]
})

export class SharedModule { }
